import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Button, Box, CircularProgress, Typography } from '@material-ui/core';
import { Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import * as api from '../api/calls'

function StripeManage({ userDetails }) {

  const [hasSubs, setSubs] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    if (userDetails && userDetails.user_detail && userDetails.user_detail.stripeCustomerID) {
      setIsLoading(true)
      const customerID = userDetails.user_detail.stripeCustomerID
      const portalRes = await api.redirectToPortal(customerID)
      if (typeof window !== `undefined`) window.location.href = portalRes.data.url
    } else {
      setSubs(false)
      console.log('No Subscriptions')
    }

  }

  return (
    <Box>
      {isLoading ? <CircularProgress /> :
        hasSubs ?
          <Button variant="contained" color="secondary" onClick={handleClick}>Manage Subscriptions</Button> : <Typography>Buy a server, cancel any time from here.</Typography>
      }
    </Box>
  )

}

export default StripeManage